import React from 'react';
import { Link } from 'react-router-dom';

const CompanyCareer: React.FC = () => {
    return (
        <>
            {/* page title */}
            <div className="container-fluid py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">Career</h6>
                        <p className="text-secondary small">Find best career and Job offers</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi"><Link to="/app/company-profile"> Company</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page">Career</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">
                {/* Hero Section */}
                <div className="card bg-theme-r-gradient text-center mb-3 mb-lg-4">
                    <div className="coverimg w-100 h-100 position-absolute top-0 start-0 opacity-25 z-index-0">
                        <img src={asset("assets/img/background-image/backgorund-image-2.jpg")} className="" alt="" />
                    </div>
                    <div className="card-body position-relative z-index-1 p-lg-5 ">
                        <h1 className="mb-1">Your first step is for Learning & Next all are for Bright Future</h1>
                        <p className="opacity-75 mb-3 mb-lg-4">You can be happy and make others also.<br /> Do good work and be good with good human beings. </p>
                        <a className="btn btn-accent">Explore Opening</a>
                    </div>
                </div>

                <div className="row gx-3 gx-lg-4 align-items-center my-4 my-lg-5">
                    <div className="col-12 col-md-4 col-xl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <h2 className="mb-2">100+</h2>
                                <p className="text-secondary">Creative & Unique Pages</p>
                            </div>
                        </div>
                        <div className="card mb-3 mb-lg-0">
                            <div className="card-body">
                                <h2 className="mb-2">200+</h2>
                                <p className="text-secondary">Flexible & Elastic widgets</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md">
                        <h2 className="mb-3">We are doing for great future of web applications design.</h2>
                        <h5 className="mb-4">Change the way you see web applications. Make it more Human friendly.</h5>
                        <p className="text-secondary">DevUIUX is creative and multipurpose template. You can use it for CRM, Business application, Intranet Application, Portal service and Many more. It comes with unlimited possibilities and 10+ predefined styles which you can also mix up and create new style. Do support and spread a word for us. </p>
                    </div>
                </div>

                <div className="card bg-theme-1-subtle my-4 my-lg-5">
                    <div className="card-body px-lg-5">
                        <div className="text-center mb-3 mb-lg-4 py-3">
                            <h4 className="mb-1">Start your career with us</h4>
                            <p className="text-secondary">Get your best job on right time</p>
                        </div>
                        <div className="row gx-3 gx-lg-4">
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <div className="card mb-3 mb-lg-4 overflow-hidden">
                                    <div className="height-150 w-100 coverimg">
                                        <img src={asset("assets/img/adminuiux/user-1.jpg")} className="mw-100" alt="" />
                                    </div>
                                    <div className="card-body">
                                        <h5 className="mb-1">Administrator</h5>
                                        <p className="mb-3">3-5 year experience</p>
                                        <p className="text-secondary">Administrator works with ground staffs and manage food, cleaning and office area decor. If you are good, having 3-5 years experience, do join us.</p>
                                        <button className="btn btn-sm btn-link">Apply Now <i className="bi bi-arrow-right"></i></button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <div className="card mb-3 mb-lg-4 overflow-hidden">
                                    <div className="height-150 w-100 coverimg">
                                        <img src={asset("assets/img/adminuiux/user-2.jpg")} className="mw-100" alt="" />
                                    </div>
                                    <div className="card-body">
                                        <h5 className="mb-1">Sr. Manager</h5>
                                        <p className="mb-3">6+ year experience</p>
                                        <p className="text-secondary">Our rocking team needs a good senior manager who can work wih 10 people team for offshore client. We need good experience in healthcare domain.</p>
                                        <button className="btn btn-sm btn-link">Apply Now <i className="bi bi-arrow-right"></i></button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <div className="card mb-3 mb-lg-4 overflow-hidden">
                                    <div className="height-150 w-100 coverimg">
                                        <img src={asset("assets/img/adminuiux/user-6.jpg")} className="mw-100" alt="" />
                                    </div>
                                    <div className="card-body">
                                        <h5 className="mb-1">Php Developer</h5>
                                        <p className="mb-3">4-6 year experience</p>
                                        <p className="text-secondary">We are looking for cost friendly developer in open-source technology like php and Laravel Yii3 to create and manage web/mobile applications.</p>
                                        <button className="btn btn-sm btn-link">Apply Now <i className="bi bi-arrow-right"></i></button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <div className="card mb-3 mb-lg-4 overflow-hidden">
                                    <div className="height-150 w-100 coverimg">
                                        <img src={asset("assets/img/adminuiux/user-9.jpg")} className="mw-100" alt="" />
                                    </div>
                                    <div className="card-body">
                                        <h5>Front-end Developer</h5>
                                        <p className="mb-3">3-5 year experience</p>
                                        <p className="text-secondary">Developer who create clean like kitchen front-end apps integration with different frontend technologies. Apply! If you wanted to work with us.</p>
                                        <button className="btn btn-sm btn-link">Apply Now <i className="bi bi-arrow-right"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row gx-3 gx-lg-4 my-4 my-lg-5">
                    <div className="col-12 col-md-4 col-lg-4 col-xl-3 py-3 mb-3 mb-lg-0">
                        <figure className="h-100 w-100 coverimg rounded d-block">
                            <img src={asset("assets/img/adminuiux/image-2.jpg")} alt="" className="" />
                        </figure>
                    </div>
                    <div className="col-12 col-md py-3 mb-3 mb-lg-0">
                        <h2 className="mb-3">Our mission is to <br />serve good UI UX design.</h2>
                        <h5 className="mb-4">We do it by ourselves with the team in which you can be a part.</h5>
                        <p className="text-secondary">DevUIUX is creative and multipurpose template. You can use it for CRM, Business application, Intranet Application, Portal service and Many more.
                            It comes with unlimited possibilities and 10+ predefined styles which you can also mix up and create new style. Do support and spread a word for us. </p>
                    </div>
                    <div className="col-12 col-md-auto offset-md-1 py-3 mb-3 mb-lg-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <h2 className="mb-1">4+</h2>
                                <p className="text-secondary">Different technology starter kit</p>
                            </div>
                        </div>

                        <div className="card ">
                            <div className="card-body">
                                <h2 className="mb-1">15 + 2</h2>
                                <p className="text-secondary">Pre-defined colors + Layout modes </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-lg-5 px-3 position-relative text-center rounded overflow-hidden mb-3 mb-lg-4 z-index-0 bg-theme-r-gradient">
                    <figure className="coverimg h-100 w-100 z-index-0 position-absolute top-0 start-0 m-0 opacity-25">
                        <img src={asset("assets/img/background-image/backgorund-image-2.jpg")} alt="" />
                    </figure>
                    <div className="row gx-3 h-100 align-items-center justify-content-center position-relative z-index-1">
                        <div className="col-12 col-md-8 col-lg-7">
                            <h2>Team build with Trust &amp; Transparency</h2>
                            <p className="opacity-75 small">We always prefer to have clear communication less headache and only creative thoughts in mind. That is why we prefer to have good working culture across the organization.</p>
                            <br />
                            <h5 className="text-center">Wanted to experience adventure? Join us now!.</h5>
                            <p className="opacity-75 text-center small mb-4">We will be happy to make ou part of our team. </p>

                            <button className="btn btn-theme">Apply now</button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default CompanyCareer;
